/**
 * A channel is a running chat; a board is bulletin-style posts; a dm is a
 * private one-to-one conversation between two staff members (t0954). All
 * three are "spaces" in the schema, but a dm has its own access rule — only
 * its two participants can ever see it, not just anyone with
 * `workspace:read` — see `modules/workspace/service.ts`.
 */
export const WORKSPACE_SPACE_KINDS = ['channel', 'board', 'dm'];
/** The kinds `POST /workspace/spaces` can create. A dm is opened through
 *  `POST /workspace/dms` instead — never through the space-management
 *  endpoint, which would let a manager see or rename a private conversation. */
export const WORKSPACE_CREATABLE_SPACE_KINDS = ['channel', 'board'];
/** Chat messages are short by nature; board posts are longer-lived
 *  announcements and can run much longer. */
export const WORKSPACE_MESSAGE_BODY_MAX = 4_000;
export const WORKSPACE_POST_BODY_MAX = 50_000;
/** Quick reactions (t1222). A fixed list, stored as text so it can grow
 *  without a migration. One reaction per person per message. */
export const WORKSPACE_REACTIONS = ['yes', 'no', 'noted', 'ok', 'checking'];
export const WORKSPACE_REACTION_LABELS = {
    yes: 'Yes',
    no: 'No',
    noted: 'Noted',
    ok: 'OK',
    checking: 'Checking',
};
//# sourceMappingURL=workspace.js.map